class heroControls {
  idx = 0
  imgIdx = 0
  heroImages = []
  line2Elem = null
  line3Elem = null
  line2Text = []
  line3Text = []
  textInterval = null
  imageInterval = null
  paused = false
  buffer = false

  constructor(heroText, heroImages, heroButton, heroVideo) {
    this.heroText = heroText
    this.heroImages = heroImages
    this.heroButton = heroButton
    this.heroVideo = heroVideo
    this.line2Elem = heroText.querySelector('.line2')
    this.line3Elem = heroText.querySelector('.line3')
    let line2 = this.heroText.querySelectorAll('.line2')
    let line3 = this.heroText.querySelectorAll('.line3')
    console.log(line2[0].textContent)
    this.line2Elem.style.opacity = '0'
    this.line3Elem.style.opacity = '0'
    for (let line of line2) {
      this.line2Text.push(line.textContent.trim())
    }
    for (let line of line3) {
      this.line3Text.push(line.textContent.trim())
    }

    setTimeout(() => {
      this.init()
    }, 800)
  }

  init() {
    this.heroButton.addEventListener('click', () => {
      let pauseButton = document.querySelector('.pause-button')
      let playButton = document.querySelector('.play-button')
      if (this.paused) {
        this.resume()
        playButton.style.opacity = '0'
        pauseButton.style.opacity = '1'
        this.paused = false
      } else {
        this.pause()
        pauseButton.style.opacity = '0'

        playButton.style.opacity = '1'
        this.paused = true
      }
    })
    let toDelete = this.heroText.querySelectorAll('.line2:not(:first-of-type)')
    toDelete[0].innerHTML = ''
    for (let i = 1; i < toDelete.length; i++) {
      toDelete[i].style.display = 'none'
    }
    toDelete = this.heroText.querySelectorAll('.line3:not(:first-of-type)')
    console.log(toDelete)
    toDelete[0].innerHTML = ''
    for (let i = 1; i < toDelete.length; i++) {
      toDelete[i].style.display = 'none'
    }
    this.start()
  }

  fadeOut() {
    this.line2Elem.style.opacity = '0'
    this.line3Elem.style.opacity = '0'
  }

  play() {
    this.fadeOut()
    setTimeout(() => {
      this.restart()
    }, 490)
  }

  resume() {
    if (this.buffer) {
      clearTimeout(this.buffer)
    }
    this.buffer = setTimeout(() => {
      this.start()
      setTimeout(() => {
        this.nextImage()
      }, 500)
    }, 1000)
    this.heroVideo.play()
  }

  pause() {
    clearInterval(this.textInterval)
    clearInterval(this.imageInterval)
    if (this.buffer) {
      clearTimeout(this.buffer)
    }
    this.heroVideo.pause()
  }

  start() {
    this.restart()
    this.textInterval = setInterval(() => {
      this.restart()
      this.nextImage()
    }, 3000)
  }

  restart() {
    this.line2Elem.style.width = '0%'
    this.line3Elem.style.width = '0%'
    this.line2Elem.style.animation = 'none'
    this.line3Elem.style.animation = 'none'
    void this.line2Elem.offsetWidth
    void this.line3Elem.offsetWidth
    //console.log(idx);

    if (this.idx < this.line2Text.length) {
      this.line2Elem.innerHTML = this.line2Text[this.idx]
      this.line3Elem.innerHTML = this.line3Text[this.idx]
    } else {
      this.line2Elem.innerHTML = this.line2Text[0]
      this.line3Elem.innerHTML = this.line3Text[0]
      this.idx = 0
    }
    this.idx++
    this.line2Elem.style.opacity = '1'
    this.line3Elem.style.opacity = '1'
    this.line2Elem.style.animation = ''
    this.line3Elem.style.animation = ''
  }

  nextImage() {
    if (this.imgIdx >= this.heroImages.length - 1) {
      this.heroImages[0].style.opacity = '1'
      for (let i = 1; i < this.heroImages.length; i++) {
        this.heroImages[i].style.opacity = '1'
      }
      this.imgIdx = 0
    } else {
      this.heroImages[this.imgIdx].style.opacity = '0'
      this.imgIdx++
    }
  }
}

export default heroControls
